import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './authConfig';
import App from './App';
import { ToastContainer, Slide } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';
import { injectStyle } from 'react-toastify/dist/inject-style';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './assests/css/customisetoast.scss';
import './assests/css/customisedatepicker.scss';

/* on demand inject toast style */
injectStyle();

export const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <BrowserRouter>
    <MsalProvider instance={msalInstance}>
      <App />
      <ToastContainer
        position='top-right'
        draggable={false}
        autoClose={6000}
        closeOnClick={true}
        theme='dark'
        className='custom-toastify'
        toastClassName='custom-toast-container'
        transition={Slide}
      />
    </MsalProvider>
  </BrowserRouter>
);
